import { Fragment, ReactElement } from 'react';
import PersonSearchMarriageNonResidentNotificationsCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-marriage-non-resident/edit-person-search';

const PersonSearchMarriageNonResidentNotificationsCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <PersonSearchMarriageNonResidentNotificationsCivilStatusShared />
    </Fragment>
  );
};

PersonSearchMarriageNonResidentNotificationsCivilStatusPage.displayName =
  'Research Marriage Non Resident Notifications CivilStatusPage component';

export default PersonSearchMarriageNonResidentNotificationsCivilStatusPage;
